export const GET_PAGE_DEFINITIONS = "GET_PAGE_DEFINITIONS"
export const GET_PAGE_DEFINITIONS_SUCCESS = "GET_PAGE_DEFINITIONS_SUCCESS"
export const GET_PAGE_DEFINITIONS_FAIL = "GET_PAGE_DEFINITIONS_FAIL"

export const ADD_NEW_PAGE_DEFINITION = "ADD_NEW_PAGE_DEFINITION"
export const ADD_PAGE_DEFINITION_SUCCESS = "ADD_PAGE_DEFINITION_SUCCESS"
export const ADD_PAGE_DEFINITION_FAIL = "ADD_PAGE_DEFINITION_FAIL"

export const UPDATE_PAGE_DEFINITION = "UPDATE_PAGE_DEFINITION"
export const UPDATE_PAGE_DEFINITION_SUCCESS = "UPDATE_PAGE_DEFINITION_SUCCESS"
export const UPDATE_PAGE_DEFINITION_FAIL = "UPDATE_PAGE_DEFINITION_FAIL"

export const DELETE_PAGE_DEFINITION = "DELETE_PAGE_DEFINITION"
export const DELETE_PAGE_DEFINITION_SUCCESS = "DELETE_PAGE_DEFINITION_SUCCESS"
export const DELETE_PAGE_DEFINITION_FAIL = "DELETE_PAGE_DEFINITION_FAIL"

export const PAGE_API_ERROR = "PAGE_API_ERROR"


